import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { dbg } from './lib/debug';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Pricing from './pages/Pricing';
import Help from './pages/Help';
import Checkout from './pages/Checkout';
import DissertationView from './pages/DissertationView';
import DissertationLive from './pages/DissertationLive';
import Generate from './pages/Generate';
import Assignments from './pages/Assignments';
import AssignmentLive from './pages/AssignmentLive';
import AssignmentView from './pages/AssignmentView';
import WorldBank from './pages/WorldBank';
import WorldBankNew from './pages/WorldBankNew';
import WorldBankTask from './pages/WorldBankTask';
import WorldBankAnalysis from './pages/WorldBankAnalysis';
import Samples from './pages/Samples';
import StructureEditor from './pages/StructureEditor';
import Admin from './pages/Admin';
import AdminTest from './pages/AdminTest';
import AdminDashboard from './pages/AdminDashboard';
import Developers from './pages/Developers';
import Terms from './pages/Terms';
import NotFound from './pages/NotFound';
import { useAuth } from './lib/auth';
import { useEffect, useState } from 'react';
import { api } from './lib/api';

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="center">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(null);
  useEffect(() => {
    if (!user) { setIsAdmin(false); return; }
    (async () => {
      try {
        const me = await api.get('/api/users/me');
        setIsAdmin(!!me.is_admin);
      } catch {
        setIsAdmin(false);
      }
    })();
  }, [user]);
  if (loading || isAdmin === null) return <div className="center">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

function RouteLogger() {
  const location = useLocation();
  useEffect(() => {
    dbg('evt', `navigation → ${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);
  return null;
}

export default function App() {
  return (
    <Layout>
    <RouteLogger />
    <ErrorBoundary>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/help" element={<Help />} />
      <Route
        path="/checkout"
        element={
          <RequireAuth>
            <Checkout />
          </RequireAuth>
        }
      />
      <Route
        path="/generate"
        element={
          <RequireAuth>
            <Generate />
          </RequireAuth>
        }
      />
      <Route path="/dissertation/:id" element={<DissertationView />} />
      <Route
        path="/dissertation/:id/live"
        element={
          <RequireAuth>
            <DissertationLive />
          </RequireAuth>
        }
      />
      <Route
        path="/assignments"
        element={
          <RequireAuth>
            <Assignments />
          </RequireAuth>
        }
      />
      <Route path="/assignment/:id" element={<AssignmentView />} />
      <Route
        path="/assignment/:id/live"
        element={
          <RequireAuth>
            <AssignmentLive />
          </RequireAuth>
        }
      />
      <Route
        path="/worldbank"
        element={
          <RequireAuth>
            <WorldBank />
          </RequireAuth>
        }
      />
      <Route
        path="/worldbank/new"
        element={
          <RequireAuth>
            <WorldBankNew />
          </RequireAuth>
        }
      />
      <Route
        path="/worldbank/task/:taskId"
        element={
          <RequireAuth>
            <WorldBankTask />
          </RequireAuth>
        }
      />
      <Route path="/worldbank/:id" element={<WorldBankAnalysis />} />
      <Route path="/samples" element={<Samples />} />
      <Route
        path="/structure-editor"
        element={
          <RequireAuth>
            <StructureEditor />
          </RequireAuth>
        }
      />
      <Route
        path="/admin"
        element={
          <RequireAdmin>
            <Admin />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/test"
        element={
          <RequireAdmin>
            <AdminTest />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/developers"
        element={
          <RequireAdmin>
            <AdminDashboard />
          </RequireAdmin>
        }
      />
      <Route path="/developers" element={<Developers />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    </ErrorBoundary>
    </Layout>
  );
}
